module.exports = __webpack_public_path__ + "media/images/icons/chart-e91026c6fcdb120b00d77469b77f1274.svg";